
import React from 'react'
import '../responsedisplay/responsedisplay.css'
import { Delete, Check, Cancel} from "@mui/icons-material"
import EditIcon from '@mui/icons-material/Edit';
import StatusContext from '../../../contexts/StatusContext'
import AITestContext from '../../../contexts/AITestContext'
import { CancelIcon } from '../customicons/CancelIcon';
import { CheckIcon } from '../customicons/CheckIcon';
import { CircleIcon } from '../customicons/CircleIcon';
import { QuestionIcon } from '../customicons/QuestionIcon';

import { ArrowForwardIconLightBlue } from '../customicons/ArrowForwardIconLightBlue';
import MarkdownResponseDisplay from '../markdown/MarkdownResponseDisplay';
import '../customicons/customicons.css'



export const DisplayTestEditMode = ({ displayprompt, onDeletePrompt,
                   onCancelDelete, onAcceptDelete,
                   onSubmitAnswer, onAcceptAnswer,
                   onResetAnswer, 
                   onMoveUp, onMoveDown,
                   disableMoveUp, disableMoveDown,
                   showprompts, seqid, total,
                   onMoreAnswer,
                   onMoreQuestion,
                   onEditTest,
                   }) => {
 

  let {
    isLoading,
    } = React.useContext(StatusContext); 

    let {
      createtestmode,
      createcollegetestmode,
      testpreview,
      showquestionsonly, 
      //showcorrectanswersonly,
    } = React.useContext(AITestContext); 

   
  return (
    <div disabled={isLoading} >
      {
        /* in testpreview mode show only first 5 question */
        (testpreview && displayprompt.id > 4) ?
        null
        :

        <div key={displayprompt.id}  className=" themeModule" style= {{height: 'auto'}}>
          {
            
            showprompts &&  
            <div className="quizTextPrompt" >
               <div>
              <span style = {{ paddingTop: '2px', fontSize:'14px'}}>({`${seqid}/${total}` })</span>
              {
                (displayprompt.response.delete === true) ?
                  <>
                    <Check className="promptIcon"  onClick={() => { !isLoading && onAcceptDelete(displayprompt)}} />
                    <Cancel className="promptIcon"  onClick={() => { !isLoading && onCancelDelete(displayprompt) }} />
                  </>
                  : 
                  <>
                  {
                      (createtestmode || createcollegetestmode) &&
                        <EditIcon className="promptIcon" style={{color:'maroon'}} onClick={() => { onEditTest(displayprompt) }} />
                  }

                  {/*
                    (createtestmode || createcollegetestmode) &&
                    <>
                    <ArrowUpward className="promptIcon" style={
                      {
                        cursor: disableMoveUp ? 'undefined' : 'pointer',
                        pointerEvents: disableMoveUp ? 'none' : 'all',
                        opacity: disableMoveUp ? 0.5 : 1
                      }} onClick={() =>{ !isLoading && onMoveUp(displayprompt.id)}} />
               
                   
                    <ArrowDownward className="promptIcon" style={
                      {
                        cursor: disableMoveDown ? 'undefined' : 'pointer',
                        pointerEvents: disableMoveDown ? 'none' : 'all',
                        opacity: disableMoveDown ? 0.5 : 1
                      }} onClick={() => { !isLoading && onMoveDown(displayprompt.id)}} />
                      </>
                  */}
                  
                  {
                  (createtestmode || createcollegetestmode) &&
                      <Delete className="promptIcon"  onClick={() => { !isLoading && onDeletePrompt(displayprompt) }} />
                  }
                  </>
              }
           
              <MarkdownResponseDisplay text={displayprompt.prompt} paragraphcolor={'maroon'}/>  
           </div>
              
            </div>
          }

         
          {
            displayprompt.response && (
            <>
            {
                displayprompt.response.answer[0][0] && (
                  <>
                  <div className="promptTextPrompt, flex-container-top">
                    {
                      (displayprompt.response.answer[0][1] === true) &&
                        <>
                          {
                            <>
                            {
                            (displayprompt.response.answer[0][2] === true && displayprompt.response.answer[0][3] === true)&&
                            <>
                              <CheckIcon />
                              <ArrowForwardIconLightBlue onClick={() => !isLoading && onMoreAnswer(displayprompt, displayprompt.prompt, displayprompt.response.answer[0][0])} />
                            </>
                            }
                            {
                              ((displayprompt.response.answer[0][2] === true && displayprompt.response.answer[0][3] === false)) &&
                               <>
                                <CancelIcon />
                                <QuestionIcon onClick={() => !isLoading && onMoreQuestion(displayprompt, displayprompt.prompt, displayprompt.response.answer[0][0])} />
                                </>
                            }
                            </>
                          }
                          {
                            displayprompt.response.answer[0][2] === false &&
                                <>
                                <div className='flex-container-top'>
                                    <CheckIcon onClick={() => { onAcceptAnswer(displayprompt, displayprompt.response.answer[0][0]) }} />
                                    <CancelIcon onClick={() => { onResetAnswer(displayprompt, displayprompt.response.answer[0][0]) }} />
                                </div>
                                </>
                          }
                        </>
                    }

                    {
                       (displayprompt.response.answer[0][1] === false && showquestionsonly === false) &&
                          <CircleIcon onClick={() => { !isLoading && onSubmitAnswer(displayprompt, displayprompt.response.answer[0][0]) }} />
                    } 
                    
                  {
                    (showquestionsonly === false) &&
                   <MarkdownResponseDisplay text={displayprompt.response.answer[0][0]}/>
                   }
                  </div>
                </>
                )
            }
            {
                displayprompt.response.answer[1][0] && (
                  <>
                  <div className="promptTextPrompt, flex-container-top">
                    {
                      
                      (displayprompt.response.answer[1][1] === true) &&
                        <>
                          
                            {
                            (displayprompt.response.answer[1][2] === true && displayprompt.response.answer[1][3] === true ) &&
                               <>
                                <CheckIcon/>
                                <ArrowForwardIconLightBlue disabled={isLoading} onClick={() => { !isLoading && onMoreAnswer(displayprompt, displayprompt.prompt, displayprompt.response.answer[1][0]) }} />
                              </>
                            }
                            {
                              (displayprompt.response.answer[1][2] === true && displayprompt.response.answer[1][3] === false ) &&
                                <>
                                <CancelIcon />
                                <QuestionIcon disabled={isLoading} onClick={() => { !isLoading && onMoreQuestion(displayprompt, displayprompt.prompt, displayprompt.response.answer[1][0]) }} />
                                </>
                            }
                            {
                              displayprompt.response.answer[1][2] === false &&
                                  <>
                                  <div  className='flex-container-top'>
                                      <CheckIcon onClick={() => { onAcceptAnswer(displayprompt, displayprompt.response.answer[1][0]) }} />
                                      <CancelIcon onClick={() => { onResetAnswer(displayprompt, displayprompt.response.answer[1][0]) }} />
                                  </div>
                                  </>
                            }
                        </>
                    }

                    {
                       (displayprompt.response.answer[1][1] === false && showquestionsonly === false) &&
                          <CircleIcon onClick={() => { !isLoading && onSubmitAnswer(displayprompt, displayprompt.response.answer[1][0]) }}/>
                    }

                    {
                      showquestionsonly === false &&
                      <MarkdownResponseDisplay text={displayprompt.response.answer[1][0]}/>
                    }
                
                  </div>
                </>
                )
            }
          

            {
             
               displayprompt.response.answer[2][0] && (
                <>
                <div className="promptTextPrompt, flex-container-top">
                  {
                    (displayprompt.response.answer[2][1] === true) &&
                     
                          <>
                            {
                              (displayprompt.response.answer[2][2] === true && displayprompt.response.answer[2][3] === true ) &&
                                <>
                                  <CheckIcon />
                                  <ArrowForwardIconLightBlue disabled={isLoading} onClick={() => { !isLoading && onMoreAnswer(displayprompt, displayprompt.prompt, displayprompt.response.answer[2][0]) }} />
                                </>
                            }
                            {
                              (displayprompt.response.answer[2][2] === true && displayprompt.response.answer[2][3] === false ) &&
                               <>
                                <CancelIcon />
                                <QuestionIcon disabled={isLoading} onClick={() => { !isLoading && onMoreQuestion(displayprompt, displayprompt.prompt, displayprompt.response.answer[2][0]) }} />
                              </>
                            }
                            {
                              displayprompt.response.answer[2][2] === false &&
                                  <div  className='flex-container-top'>
                                      <CheckIcon onClick={() => { onAcceptAnswer(displayprompt, displayprompt.response.answer[2][0]) }} />
                                      <CancelIcon onClick={() => { onResetAnswer(displayprompt, displayprompt.response.answer[2][0]) }} />
                                  </div> 
                            }
                          </>
                      }
                 
                      {
                        (displayprompt.response.answer[2][1] === false && showquestionsonly === false) &&
                          <CircleIcon onClick={() => { !isLoading && onSubmitAnswer(displayprompt, displayprompt.response.answer[2][0]) }} />
                      }
                    {
                      showquestionsonly === false &&
                      <MarkdownResponseDisplay text={displayprompt.response.answer[2][0]}/>
                    }
                  
                </div>
                </>
              )
            }
         
         </>
        )}
        <br></br>
        </div>
      }


    </div>
  )
}


DisplayTestEditMode.defaultProps = {
  showprompts: true,
};

export default DisplayTestEditMode
